import { render } from "./BannersList.vue?vue&type=template&id=56b498e7&scoped=true"
import script from "./BannersList.vue?vue&type=script&lang=js"
export * from "./BannersList.vue?vue&type=script&lang=js"

import "./banner.scss?vue&type=style&index=0&id=56b498e7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56b498e7"]])

export default __exports__